import { type HTMLAttributes, type PropsWithChildren } from 'react';
import clsx from 'clsx';
import capitalize from 'lodash.capitalize';

import { type Repub } from '@cx-modules/types';

import { formatPrice } from '~/configuration/betting-insights/utils/formatPrice';
import {
  featureFlags,
  useFeatureFlag } from
'~/providers/feature-flag-provider';
import { type SubsProduct } from '~/types/subs-product';
import { getCurrencySymbol } from '~/utils/getCurrencySymbol';
import { SUBSCRIPTION_TERM } from '~/utils/stripeProductValidators';

import styles from './styles/Hero.module.css';
import { Button } from './cxy';

export const Hero = ({
  children,
  className,
  currentPath,
  hasActiveSubscription,
  hasCancelledSubscription,
  monthlyProduct,
  repub,
  shouldHideDetailsMobile,
  yearlyProduct,
  ...props








}: {currentPath: string;hasActiveSubscription: boolean;hasCancelledSubscription: boolean;monthlyProduct?: SubsProduct;repub: Repub;shouldHideDetailsMobile?: boolean;yearlyProduct?: SubsProduct;} & PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  const isHeroPricingEnabled = useFeatureFlag(
    featureFlags.SUBS__PLUS__HERO_PRICING
  );

  return (
    <div
      className={clsx(styles.hero, className)}
      data-testid="hero-content"
      {...props}>

			<div
        className={clsx(styles.textWrapper, {
          [styles.hideDetailsOnMobile]: shouldHideDetailsMobile
        })}>

				{children}
			</div>
			{isHeroPricingEnabled &&
      yearlyProduct &&
      monthlyProduct &&
      !hasActiveSubscription &&
      <div className={styles.pricingSection}>
						{[monthlyProduct, yearlyProduct].map((product) => {
          const isAnnual = product.term === SUBSCRIPTION_TERM.ANNUAL;
          const monthlyPrice = isAnnual ?
          Math.floor(product.price / 12 * 100) / 100 :
          product.price;
          return (
            <div
              className={`${styles.priceSelection} ${
              isAnnual ? styles.bestValueBorder : ''}`
              }
              data-testid={`${isAnnual ? 'annual-price' : 'monthly-price'}`}
              key={product.id}>

									{isAnnual &&
              <p className={styles.bestValueTag}>Best Value</p>
              }
									<p className={styles.term} data-testid="term">
										{isAnnual ? 'Annual' : capitalize(product.term)}
									</p>
									<p className={styles.price} data-testid="price">
										<span className={styles.monthlyCost}>
											{getCurrencySymbol(product.currency)}
											{formatPrice(monthlyPrice).whole}
										</span>
										.{formatPrice(monthlyPrice).decimal} /month
									</p>
									<p className={styles.paid} data-testid="paid-term">
										Paid {capitalize(product.term)}
									</p>
									<Button
                asChild
                className={styles.subscribeButton}
                variant="secondary">

										<a
                  href={`/${repub.toLowerCase()}/plus?redirectTo=${currentPath}#plans`}>

											{hasCancelledSubscription ?
                  <>
													<span className={styles.fullText}>Subscribe now</span>
													<span className={styles.shortText}>
														Subscribe now
													</span>
												</> :

                  <>
													<span className={styles.fullText}>
														Start 7-Day Free Trial
													</span>
													<span className={styles.shortText}>
														Start Free Trial
													</span>
												</>
                  }
										</a>
									</Button>
								</div>);

        })}
					</div>
      }
		</div>);

};